export const CSentryTags = {
    URL: 'apiUrl',
    STATUS: 'apiStatus',
    CODE: 'apiCode',
    MESSAGE: 'apiMessage',
    REQUEST_ID: 'apiRequestId'
} as const;